import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  OnInit,
  ComponentFactoryResolver,
  ViewContainerRef,
  OnChanges,
  Renderer2,
  Input
} from '@angular/core';

import { Subject } from 'rxjs';
import * as moment from 'moment-timezone';
import { UserInfoService } from '../shared/services/security.service';
import { DashboardSubject } from '../appointments/dashboard/dashboard-subject';
import { AppointmentsService } from '../appointments/appointments.service';
import { CalendarEventAction,CalendarEvent,CalendarEventTimesChangedEvent } from '../shared/angular-calendar';
import { LoaderService } from '../shared/loader-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { SlotsService } from '../slots/slots.service';
import { CssVarsService } from '../shared/services/cssVarsService.service';
import { SlotDataService } from '../slots/slots-data.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { SharedService } from '../shared/services/shared.service';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import * as QuillNamespace from "quill";
import { QuillEditorComponent } from 'ngx-quill/src/quill-editor.component';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { EmailSmsDataService } from '../shared/services/email-sms-data.service';
import { EmailSmsSubject } from '../shared/services/email-sms-subject';

import { environment } from '../../environments/environment';
import { EmailSmsHelperUtils } from '../shared/services/email-sms-helper';
import { QuizHelperUtil } from '../shared/services/QuizHelper.util';
import { of } from 'rxjs/observable/of';
import { FroalaEditorOptions } from '../shared/services/template-froala-options';
import { VariablePopupService } from '../shared/services/variable-popup.service';
import { languageEnum } from '../shared/enum-files/languageEnum';
import { ShareConfigService } from '../shared/services/shareConfig.service';
import { CommunicationMessageTypes } from '../shared/enum-files/general-enums';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  }
};
let Quill: any = QuillNamespace;

declare var cloudinary: any;
declare var $: any;

@Component({
  selector: 'app-recruiter-reschedule',
  templateUrl: './recruiter-reschedule.component.html',
  styleUrls: ['./recruiter-reschedule.component.css']
})
export class RecruiterRescheduleComponent implements OnInit {
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild(QuillEditorComponent)
  quill: QuillEditorComponent;
  CM_accepted_formats = ['image'];
  public notificationType = 4;
  public language: string;
  public TimeZoneList = [];
  public timezoneid;
  public currentLang = 'nl-NL';
  public logoUrl: string;
  public view: string = 'month';
  public viewDate: Date = new Date();
  public activeDayIsOpen;
  public timeslots = [];
  public modalRef: BsModalRef;
  public message: string;
  public selectedSlot = '';
  public selectedDate = '';
  public SendMail: boolean = false;
  public officeList = []
  private Date;
  public modalData: {
    action: string;
    event: CalendarEvent;
  };
  public officeId;
  public body = {
    AppointmentCode: "",
    Subject:"",
    Note: "",
    FilePath: [],
    SmsText: "",
    OfficeInfo: {},
    LeadUserInfo: {},
    SendMail:false
  }
  public calendarDateSelected:Date = null;
  public officeObject = {}
  automationTemObjPreview:any = {};

  public actions: CalendarEventAction[] = [
    {
      label: '<i class="fa fa-fw fa-pencil"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
      }
    },
    {
      label: '<i class="fa fa-fw fa-times"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter(iEvent => iEvent !== event);
      }
    }
  ];
  public refresh: Subject<any> = new Subject();
  public events = [];

  //dynamic component instance(data)
  public data;
  public spinning: boolean = false;
  public timezone;
  public locale;
  public details;
  private appointmentCode;
  public isChecked: boolean = false;
  public dataArrived: boolean = false;
  public selectedTimeZone:string = "";
  public availableTimeZonesList:any = [];


  public variables = [];
  public buttonValues = [];
  public templateId;
  public languageChange;
  public addEmailForm: FormGroup;
  public defaultTemplateSubscription;
  public getTemplateSubscription;
  public saveTemplateSubscription;
  public templateSubscription;
  public imageORvideo;
  public imageURL;
  smsDefaultModules = {
    toolbar: [["showHtml"]]
  };
  public templateList;
  public isExternal;
  public externalLang;
  public emailSignature;
  public emailBody;
  public froalaEditorOptions = new FroalaEditorOptions();
  public froalaEditorOptionsSMS = new FroalaEditorOptions();
  public options: object;
  public isFilterList: boolean = false;
  public allowedVariblesFor: string = 'appointment';
  public isOpenPopup: boolean = false;

  smsOptions_en = [
    {
      groupName: "Client",
      options: [
        {
          name: "First Name : %fname%",
          value: "%fname%"
        },
        {
          name: "Last Name : %lname%",
          value: "%lname%"
        },
        {
          name: "Phone : %phone%",
          value: "%phone%"
        },
        {
          name: "Email : %email%",
          value: "%email%"
        },
        {
          name: "Lead Id : %leadid%",
          value: "%leadid%"
        }
      ]
    },
    {
      groupName: "Appointment",
      options: [
        {
          name: "Type : %atype%",
          value: "%atype%"
        },
        {
          name: "Duration : %duration%",
          value: "%duration%"
        },
        {
          name: "Date and Time : %datetime%",
          value: "%datetime%"
        },
        {
          name: "Office : %office%",
          value: "%office%"
        },
        {
          name: "Scheduling Link : %slink%",
          value: "%slink%"
        },
        {
          name: "Add to iCal/Outlook Calendar : %ical%",
          value: "%ical%"
        },
        {
          name: "Add to Google Calendar : %gcal%",
          value: "%gcal%"
        },
        {
          name: "Reschedule/Cancel Appointment : %rclink%",
          value: "%rclink%"
        },
        {
          name: "Source Name : %sourcename%",
          value: "%sourcename%"
        }
      ]
    }
  ];

  smsOptions_nl = [
    {
      groupName: "Client",
      options: [
        {
          name: "Voornaam : %fname%",
          value: "%fname%"
        },
        {
          name: "Achternaam : %lname%",
          value: "%lname%"
        },
        {
          name: "Telefoon : %phone%",
          value: "%phone%"
        },
        {
          name: "Email : %email%",
          value: "%email%"
        },
        {
          name: "Lead Id : %leadid%",
          value: "%leadid%"
        }

      ]
    },
    {
      groupName: "Appointment",
      options: [
        {
          name: "Type : %atype%",
          value: "%atype%"
        },
        {
          name: "Tijd : %duration%",
          value: "%duration%"
        },
        {
          name: "Datum en tijd : %datetime%",
          value: "%datetime%"
        },
        {
          name: "Kantoor : %office%",
          value: "%office%"
        },
        {
          name: "Scheduling Link : %slink%",
          value: "%slink%"
        },
        {
          name: "Toevoegen aan Ical / Outlook-agenda : %ical%",
          value: "%ical%"
        },
        {
          name: "Voeg toe aan Google Agenda : %gcal%",
          value: "%gcal%"
        },
        {
          name: "Plannen/Annuleren afspraak : %rclink%",
          value: "%rclink%"
        },
        {
          name: "Naam bron : %sourcename%",
          value: "%sourcename%"
        }
      ]
    }
  ];
  defaultModules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"], // toggled buttons
      ["blockquote", "code-block"],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }], // superscript/subscript
      // [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
      // [{ 'direction': 'rtl' }],                         // text direction
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ align: [] }],
      ["clean"], // remove formatting button

      ["link"],
      ["showHtml2"] // link and image, video
    ]
  };
  public optionsSMS:object;
  public islanguageChange:boolean = false;
  public isEmailVariablesPopupEnabled: boolean = false;
  public isReadyToViewWhatsAppTemplate: boolean = false;
  public isValidWhatsAppTemplate: boolean = false;
  public isVisibleMediaLibrary:boolean=false;
  public shareTemplate;

  constructor(
    private appointmentsService: AppointmentsService,
    private translate: TranslateService,
    private slotsDataService: SlotDataService,
    private userInfoService: UserInfoService,
    private activatedRoute : ActivatedRoute,
    private slotsService : SlotsService,
    private router : Router,
    private slotDataService : SlotDataService,
    private loaderService: LoaderService,
    private cssVarsService : CssVarsService,
    private modalService: BsModalService,
    private sharedService : SharedService,
    private notificationsService : NotificationsService,
    private dashboardSubject: DashboardSubject,
    private renderer: Renderer2,
    private helperUtil: EmailSmsHelperUtils,
    private _fb: FormBuilder,
    private emailSmsDataService: EmailSmsDataService,
    private emailSmsSubject: EmailSmsSubject,
    private variablePopupService: VariablePopupService,
    private shareConfigService: ShareConfigService
    
    
    ) {
      this.variables = this.helperUtil.VARIABLE_FIELD;
      this.buttonValues = this.helperUtil.BUTTON_FIELDS;
      this.isExternal = this.activatedRoute.snapshot.queryParams["isExternal"];
      this.externalLang = this.activatedRoute.snapshot.queryParams["lang"];
      this.makeQuillEditorToReplacePTagWithDiv();

     }
     languages = [{
      name: 'English',
      value: 'en-US'
    }, {
      name: 'Nederlands',
      value: 'nl-NL'
    }, {
      name: 'Polish',
      value: 'pl-PL'
    }]
public show = false;

/**
 * Quill Editor  by default supports p tag to wrap the content due to which extra margin is added when send to mail
 * We have replaced the default `p` tag with div tag so that the extra margin is removed
 */
makeQuillEditorToReplacePTagWithDiv() {
  var Block = Quill.import("blots/block");
  Block.tagName = "DIV";
  Quill.register(Block, true);
}

  ngOnInit() {
    this.getAllLanguageList();
    this.options = this.froalaEditorOptions.setEditorOptions(2000);
    this.froalaEditorOptions.customPopupBtn();
    this.optionsSMS = this.froalaEditorOptionsSMS.setEditorOptions(2000);
    this.optionsSMS['toolbarButtons'] = ['my_dropdown'];
    this.froalaEditorOptionsSMS.customPopupBtn();
   //this.dynamicDropdown();
    if(this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams['AppointmentCode']){
      this.appointmentCode = this.activatedRoute.snapshot.queryParams['AppointmentCode'];
    }
    // this.fetchData();
    this.createForm();
  this.languageChange = this.translate.currentLang;
  this.translate.onLangChange.subscribe(language => {
    this.languageChange = language.lang;
  });
    this.logoUrl = this.slotsDataService.getLogoUrl();
    if(this.isExternal){
      if(this.externalLang == languageEnum.Dutch){
        this.language = "nl-NL";
      }else if(this.externalLang == languageEnum.English){
        this.language = "en-US";
      }else{
        this.language = "pl-PL";
      }
    }else{
    this.language = localStorage.getItem('language-slots');
    }
    if(this.language == 'en-US' || this.language == 'nl-NL' || this.language == "pl-PL" || this.language == "de-DE"){
      this.onlangChange(this.language);
      this.currentLang = this.language
    }else{
      this.onlangChange('nl-NL')
      this.currentLang = 'nl-NL'
    }
   moment.tz.names().forEach((timezone,i)=> {
      this.TimeZoneList.push({
        label:timezone,
        value:i.toString()
      })
    });
    
    var localTimezone = this.slotsDataService.timezone ? 
                        this.slotsDataService.timezone : 
                        'Europe/Amsterdam';
    this.slotsDataService.timezone = localTimezone;
    
    this.TimeZoneList.forEach(timezone=>{
      if(timezone.label == localTimezone){
        this.timezoneid = timezone.value.toString()
        return;
      }
    })
    
    this.getTimeZoneList();
    this.getAppointmentSlots();
    if(this.isExternal){
      if(this.externalLang == 1){
        this.locale = "nl-NL";
      }else{
        this.locale = "en-US";
      }
    }else{
    this.locale = localStorage.getItem("language") == 'en-US' ? 'en' : localStorage.getItem("language") == 'pl-PL' ? 'pl': 'nl'
    }
    this.timezone = this.slotDataService.timezone

    this.body['AppointmentBookingCode'] = this.appointmentCode;    
    
  }

  getTimeZoneList(){
    this.availableTimeZonesList = [];

    this.slotsService.getTimeZoneList(true).subscribe((data:any) => {
      if(data && data.length > 0){
        data.map((currObj:any,index:number,list:any) => {
          if((index+1) < list.length){
            this.availableTimeZonesList.push({"label":currObj.DisplayName,"value":currObj.Id});
          }
          else{
            this.availableTimeZonesList = [...this.availableTimeZonesList, {"label":currObj.DisplayName,"value":currObj.Id}];
          }
        });
      }
      
      this.slotDataService.availableTimeZonesList = this.availableTimeZonesList;
    });
  }

  onTimeChange(){
    this.slotDataService.timezone = this.selectedTimeZone;
    this.getAppointmentSlots();
  }

  getAppointmentSlots(){
    this.slotsService.getAppointmentSlots(1, this.appointmentCode,1,this.selectedTimeZone, true)
    .subscribe(
      data => {
        this.currentLang = 'nl-NL';
        if(data.Language){
          if(data.Language == languageEnum.English){
            this.currentLang = 'en-US';
          }else if(data.Language == languageEnum.Polish){
            this.currentLang = 'pl-PL';
          }else if(data.Language == languageEnum.German){
            this.currentLang = 'de-DE';
          }
        }
        if(data.ClientCode){
          this.getTempSignature(data.ClientCode);
        }
        
        if(!this.selectedTimeZone && data && data.CalendarTimeZoneId){
          this.selectedTimeZone = data.CalendarTimeZoneId;
          this.slotDataService.timezone = this.selectedTimeZone;
        }
        
          this.onlangChange(this.currentLang);
        
        this.show = true;
        this.details = data;
        if(this.details.BookingSlots && this.details.BookingSlots.length > 0){
          this.viewDate = this.details.BookingSlots[0].Date;
          this.Date = this.details.BookingSlots[0].Date;
        }
        this.cssVarsService.setVariables({
          '--primary-color': this.details.PrimaryBrandingColor,
          '--secondary-color': this.details.SecondaryBrandingColor
        });     
    this.templateId = this.details.RescheduledNotificationTemplateId; 
    this.fetchData();
    // this.insertVariable();
    if(this.details.OfficeInfo){
      this.officeId = this.details.OfficeInfo.Id;
    }
        if (this.templateId) {
          this.isReadyToViewWhatsAppTemplate = false;
          this.fetchTemplateBody();
        } 
        else{
          this.isReadyToViewWhatsAppTemplate = true;
        }
    
    this.body['LeadUserInfo'] = JSON.parse(JSON.stringify(this.details.LeadUser));

    // if(this.calendarDateSelected){
    //   let calCellId:string = moment(this.calendarDateSelected).format("DDMMYYYY").toString();
    //   // document.getElementById(calCellId).parentElement.click();
    //   setTimeout(() => {
    //     document.getElementById(calCellId).parentElement.click();
    //   }, 1000)
    // }
        if(data.BookingSlots && data.BookingSlots.length == 0 && data.BookingSlotsShiftwise && data.BookingSlotsShiftwise.length == 0){
          window.parent.postMessage({
            'message': 'success',
            'isSlotBook' : true
          }, "*");
        }
      }
    );
  }


  /**
   * Function called when language changes
   */
  onlangChange(ln) {
      this.islanguageChange = false;
      this.translate.use(ln);
      if(!this.isExternal){
        localStorage.setItem('language', ln);
        localStorage.setItem('language-slots', ln);
      }
      this.slotsService.setLanguage(ln);
      setTimeout(() => {
        this.locale = localStorage.getItem("language") == 'en-US' ? 'en' : localStorage.getItem("language") == 'pl-PL' ? 'pl': 'nl'
      this.islanguageChange = true;
      },1000);
  }

  /**
   * Function to set timezone
   * @param e 
   */
  setTimezone(e){
    var date = new Date();
    var m  = moment(date).tz(e.label)
    this.slotsDataService.timezoneOffset = m._offset * 60 * 1000 * -1;
    this.slotsDataService.timezone = e.label;
    this.slotsService.timezoneChange(true);

  }

  dynamicDropdown() {
    let option: any = {};
      option = {
        "%fname%": 'First Name : %fname%',
        "%lname%": 'Last Name : %lname%',
        "%phone%": 'Phone number : %phone%',
        "%email%": 'E-mail address: %email%',
        "%leadid%": 'ID : %leadid%',
        "%atype%": 'Type : %atype%',
        "%duration%": 'Duration : %duration%',
        "%datetime%": 'Date & time : %datetime%',
        "%slink%": 'Scheduling Link : %slink%',
        "%office%": 'Team : %office%',
        "%ical%": 'Outlook calendar link : %ical%',
        "%gcal%": 'Google calendar link : %gcal%',
        "%rclink%": 'Reschedule/ cancellation link : %rclink%',
        "%sourcename%": 'Source name : %sourcename%',
        '%signature%': 'Signature : %signature%'
      }

    let self = this;
    $.FroalaEditor.DefineIcon('my_dropdown', { NAME: 'cog' });
    $.FroalaEditor.RegisterCommand('my_dropdown', {
      title: 'Insert Variable Field',
      type: 'dropdown',
      focus: false,
      undo: true,
      refreshAfterCallback: true,
      options: option,
      callback: function (cmd, val) {
        this.html.insert(val, false);
      },
    });
  }

  insertVariable() {
    var that = this;
    var en_str_reschedule = `<select id="dropdownnew" class="form-control myDropdown ql-size en_str2_re_class">
    <option value="">Insert Variable Field</option>
    <optgroup label="Client">
      <option value="%fname%" >First Name : %fname%</option>
      <option value="%lname%" >Last Name : %lname%</option>
      <option value="%phone%" >Phone : %phone%</option>
      <option value="%email%" >Email : %email%</option>
      <option value="%leadid%">Lead Id : %leadid%</option>
      <option value="%signature%">Signature : %signature%</option>
    </optgroup>
    <optgroup label="Appointment">
      <option value="%atype%" >Type : %atype%</option>
      <option value="%duration%" >Duration : %duration%</option>
      <option value="%datetime%" >Date and Time : %datetime%</option>
      <option value="%office%" >Office : %office%</option>
      <option value="%slink%" >Scheduling Link : %slink%</option>
      <option value="%ical%" >Add to iCal/Outlook Calendar : %ical%</option>
      <option value="%gcal%"this >Add to Google Calendar : %gcal%</option>
      <option value="%rclink%" >Reschedule/Cancel Appointment : %rclink%</option>
      <option value="%sourcename%" >Source Name : %sourcename%</option>      
    </optgroup>
    </select>`;
 
    var nl_str_reschedule = `<select id="dropdownnew2" class="form-control myDropdown ql-size nl_str2_re_class">
    <option value="">Insert Variable Veld</option>
    <optgroup label="Client">
      <option value="%fname%" >Voornaam : %fname%</option>
      <option value="%lname%" >Achternaam : %lname%</option>
      <option value="%phone%" >Telefoon : %phone%</option>
      <option value="%email%" >Email : %email%</option>
      <option value="%leadid%">Lead Id : %leadid%</option>
      <option value="%signature%">Signature : %signature%</option>
    </optgroup>
    <optgroup label="Appointment">
      <option value="%atype%" >Type : %atype%</option>
      <option value="%duration%" >Tijd : %duration%</option>
      <option value="%datetime%" >Datum en tijd : %datetime%</option>
      <option value="%office%" >Kantoor : %office%</option>
      <option value="%slink%" >Scheduling Link : %slink%</option>
      <option value="%ical%" >Toevoegen aan Ical / Outlook-agenda : %ical%</option>
      <option value="%gcal%" >Voeg toe aan Google Agenda : %gcal%</option>
      <option value="%rclink%" >Plannen/Annuleren afspraak : %rclink%</option>
      <option value="%sourcename%" >Naam Bron : %sourcename%</option>      
    </optgroup>
    </select>`;

    var customButton1 = document.querySelectorAll(".ql-showHtml2");


    if(customButton1 && customButton1[0] && customButton1[0].parentElement){
      var elementsToRemove = customButton1[0].parentElement.querySelector("select");
      if(elementsToRemove){
        elementsToRemove.remove();
      }
    }

if(customButton1.length >0)
{
    if(this.languageChange == 'en-US')
    {
    
    customButton1[0].parentElement.insertAdjacentHTML("beforeend", en_str_reschedule);
    document
    .getElementsByClassName("en_str2_re_class")[0]
    .addEventListener("change", ($event)=> {
      
      $(".beta .ql-editor").focus();
      that.pasteHtmlAtCaret($event.target["value"]);
      $event.target["value"] = "";
    });
  }
  else if(this.languageChange == 'nl-NL')
  {
    customButton1[0].parentElement.insertAdjacentHTML("beforeend", nl_str_reschedule);
    document
        .getElementsByClassName("nl_str2_re_class")[0]
        .addEventListener("change",($event)=>{
          
          $(".beta .ql-editor").focus();
          that.pasteHtmlAtCaret($event.target["value"]);
          $event.target["value"] = "";
        });
  }
}
customButton1[0].classList.add("hide");

  }

  isCheckedStyle : {};
  isCheckedChange(e){  
    if(e)
    {
      return this.isCheckedStyle = {'display':'none'};
    }
    else{
      return this.isCheckedStyle = {};
    }
  }
  /**
   * Fetch rescheduling data monthwise
   * date is passed to server and server returns the data for the month in which the date is mentioned
   */

  fetchData(date?) {
    this.loaderService.show();
    this.slotsService.rescheduleAppointments(-1, moment(this.viewDate).format("YYYY-MM-DD"), this.appointmentCode,1,this.slotDataService.timezone, true).subscribe((data) => {
      this.loaderService.hide()
        this.events = []
        data.BookingSlotsShiftwise.forEach(slot => {
          var timeSlots = [];
          slot.MorningSlots.forEach(noon=>{
            timeSlots.push({start : noon.StartTime,end : noon.EndTime})
          })
          slot.AfternoonSlots.forEach(noon=>{
            timeSlots.push({start : noon.StartTime,end : noon.EndTime})
          })
          slot.EveningSlots.forEach(noon=>{
            timeSlots.push({start : noon.StartTime,end : noon.EndTime})
          })
          slot.NightSlots.forEach(night=>{
            timeSlots.push({start : night.StartTime,end : night.EndTime})
          })
          
          this.events.push({
            start: new Date(slot.Date),
            end: new Date(slot.Date),
            title: '',
            color: colors.red,
            actions: this.actions,
            CalendarId: slot.CalendarId,
            // TimeSlots: slot.TimeSlots.filter((date) => { return new Date(date) })
            TimeSlots: timeSlots
          })

        });

        this.refresh.next();
        //this.insertVariable();
        if(this.calendarDateSelected){
          let calCellId:string = moment(this.calendarDateSelected).format("DDMMYYYY").toString();
          
          if(document.getElementById(calCellId) && document.getElementById(calCellId).parentElement){
            setTimeout(() => {
              document.getElementById(calCellId).parentElement.click();
            }, 500)
          }
        }
      }, (error) => {
        this.loaderService.hide()
        var message = JSON.parse(error._body)
        if(error.status == 501 && message.message == `Appointment booking not found for code ${this.appointmentCode}`)
        {
          message.message = 'this not a dead end. Looks like you tried to open incorrect page URL.'
          message['message1']='Please get the correct one and try again.'
          this.sharedService.setErrorMessage(message);
          this.router.navigate(['error']);
          return of(false);
        }
    })
  }

  /**
   * Function to call when day clicked
   * @param param0 
   */
  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    
    //this.currentDayAppointmentSummary = events;
    this.calendarDateSelected = date;
    this.selectedSlot = '';
    this.selectedDate = ''
    this.spinning = true;
    this.timeslots = []
    setTimeout(() => {
      
      this.spinning = false;
      if (events.length != 0) {
        this.timeslots = events[0]['TimeSlots'];
        this.selectedDate = moment(events[0].start).format("YYYY-MM-DD")
      } else {
        this.timeslots = []
      }
    }, 200)

  }

  openModalReschedule(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  //Modal delete confirm
  confirm(): void {
    this.submit();
    $("#del")
      .addClass("closet")
      .trigger("click");
    this.modalRef.hide();
  }

  //Modal delete decline
  decline(): void {
    this.message = "Declined!";
    this.modalRef.hide();
  }
  

  /**
   * Submit
   */
  submit() {

    if (this.isChecked) {
      this.body['SendMail'] = false;
    }
    else {
      // this.loaderService.show();
      // let listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObj(this.addEmailForm.value.Body);
      // let listOfUsedVariableObjSms = this.variablePopupService.getListOfUsedVariableObj(this.addEmailForm.value.SMSText);
      let listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObjV3(this.addEmailForm.value.Body);
      let listOfUsedVariableObjSms = this.variablePopupService.getListOfUsedVariableObjV3(this.addEmailForm.value.SMSText);
      this.body['SendMail'] = true;
      this.body['Subject'] = this.addEmailForm.value.Subject;
      // this.body['Note'] = this.variablePopupService.updateTemplateVarHTMLIntoVariable(this.addEmailForm.value.Body, listOfUsedVariableObj, "body");
      // this.body['SmsText'] = this.variablePopupService.updateTemplateVarHTMLIntoVariable(this.addEmailForm.value.SMSText, listOfUsedVariableObjSms, "sms");
      this.body['Note'] = this.variablePopupService.updateTemplateVarHTMLIntoVariableCommon(this.addEmailForm.value.Body);
      this.body['SmsText'] = this.variablePopupService.updateTemplateVarHTMLIntoVariableCommon(this.addEmailForm.value.SMSText);
      this.body['SmsText'] = this.body['SmsText'] ? this.body['SmsText'].replace(/&nbsp;/g, " ").replace(/<br(\s\/)*>/g, "\n") : '';
      this.addEmailForm.value.TemplateAttachmentList.forEach(element => {
        this.body.FilePath.push(this.pushData(element))
      });
      this.body['emailLinkVariable'] = this.addEmailForm.controls.EmailLinkVariable.value;

      //WhatsApp Template
      this.body['WhatsApp'] = null;
      if (this.shareConfigService.selectedWhatsAppTemplate[this.notificationType] && Object.keys(this.shareConfigService.selectedWhatsAppTemplate[this.notificationType]).length > 0) {
        // let listOfUsedVariableObjFolloUp = this.variablePopupService.getListOfUsedVariableObj(this.shareConfigService.selectedWhatsAppTemplate[this.notificationType].followUpMessage);
        let listOfUsedVariableObjFolloUp = this.variablePopupService.getListOfUsedVariableObjV3(this.shareConfigService.selectedWhatsAppTemplate[this.notificationType].followUpMessage);
        let readyToSend: any = {
          "hsmTemplateId": this.shareConfigService.selectedWhatsAppTemplate[this.notificationType].id,
          "hsmTemplateLanguageCode": this.shareConfigService.selectedWhatsAppTemplate[this.notificationType].templateLanguage,
          "templateParameters": this.shareConfigService.selectedWhatsAppTemplate[this.notificationType].params,
          // "followUpMessage": this.variablePopupService.updateTemplateVarHTMLIntoVariable(this.shareConfigService.selectedWhatsAppTemplate[this.notificationType].followUpMessage, listOfUsedVariableObjFolloUp, 'followUp')
          "followUpMessage": this.variablePopupService.updateTemplateVarHTMLIntoVariableCommon(this.shareConfigService.selectedWhatsAppTemplate[this.notificationType].followUpMessage)
        }
        readyToSend.followUpMessage = readyToSend.followUpMessage ? this.variablePopupService.convertToPlainText(readyToSend.followUpMessage) : "";
        this.body['WhatsApp'] = JSON.parse(JSON.stringify(readyToSend));
      }
    }
    this.body['bookingDate'] = this.selectedDate
    this.body['bookingTime'] = this.selectedSlot
    this.body['timezone'] = this.slotDataService.timezone;
    this.body['isClient'] = false;
    this.body["userType"] = 1;

    this.slotsService.bookAppointment(this.body, true)
      .subscribe((data) => {
        this.loaderService.hide();
        this.dashboardSubject.setRescheduled(true)
        this.selectedSlot = '';
        this.selectedDate = '';
        // this.SendMail = false;
        this.sharedService.getTranslatedNotification(16);
      }, (error) => {
        let data = JSON.parse(error._body)
        this.loaderService.hide();
        this.notificationsService.error(data.message);
      })
  }

  pushData(data){
    return {
      FileName: data.FileName,
      FileLink: data.FileUrl
    }
  }


  /**
   * When sms variable is selected
   */
  onSmsVariableSelect = (value)=> {
    this.isFilterList = false;
    var cursorPos = $("#sms-textarea1").prop("selectionStart");
    var v = $("#sms-textarea1").val();
    var textBefore = v.substring(0, cursorPos);
    var textAfter = v.substring(cursorPos, v.length);
    this.addEmailForm.controls.SMSText.patchValue(
      textBefore + value + textAfter
    );
    // $('#sms-textarea').val(textBefore + value + textAfter);
    $('#charNums').text(this.addEmailForm.controls.SMSText.value.length);
  }
  addCampaignNameText = ()=> {
    var cursorPos = $("#subject1").prop("selectionStart");
    var v = $("#subject1").val();
    var textBefore = v.substring(0, cursorPos);
    var textAfter = v.substring(cursorPos, v.length);
    this.addEmailForm.controls.Subject.patchValue(
      textBefore + "%sourcename%" + textAfter
    );
  }

  /**
   * Function to fetch template body
   */
  fetchTemplateBody() {
    this.loaderService.show();
    this.getTemplateSubscription = this.slotsService
      .getTemplateBodyWithValueById(this.templateId, this.appointmentCode, true)
      .subscribe(
        data => {
          this.loaderService.hide();
          // let listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObj(data.Body);
          // let listOfUsedVariableObjSms = this.variablePopupService.getListOfUsedVariableObj(data.SMSText);
          let listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObjV3(data.Body);
          let listOfUsedVariableObjSms = this.variablePopupService.getListOfUsedVariableObjV3(data.SMSText);
          this.addEmailForm.patchValue({
            Id: data.Id,
            // Body: this.variablePopupService.updateTemplateVariableIntoHTML(data.Body, listOfUsedVariableObj, 'body'),
            // SMSText: this.variablePopupService.updateTemplateVariableIntoHTML(data.SMSText, listOfUsedVariableObjSms, 'sms'),
            Body: this.variablePopupService.updateTemplateVariableIntoHTMLV3(data.Body,true),
            SMSText: this.variablePopupService.updateTemplateVariableIntoHTMLV3(data.SMSText),
            Subject: data.Subject,
            EmailLinkVariable: data.EmailLinkVariable == null ? '' : data.EmailLinkVariable
          });

          // For WhatsApp Template
          if (data.WhatsApp && Object.keys(data.WhatsApp).length > 0) {
            // let listOfUsedVariableObjFolloUp = this.variablePopupService.getListOfUsedVariableObj(data.WhatsApp.FollowUpMessage);
            let listOfUsedVariableObjFolloUp = this.variablePopupService.getListOfUsedVariableObjV3(data.WhatsApp.FollowUpMessage);
            let tempWhatsApp: any = {};
            let isTemplateIdValid: boolean = false;
            tempWhatsApp.hsmTemplateId = data.WhatsApp.HsmTemplateId;
            tempWhatsApp.hsmTemplateLanguageCode = data.WhatsApp.HsmTemplateLanguageCode;
            // tempWhatsApp.followUpMessage = this.variablePopupService.updateTemplateVariableIntoHTML(data.WhatsApp.FollowUpMessage, listOfUsedVariableObjFolloUp, 'followUp');
            tempWhatsApp.followUpMessage = this.variablePopupService.updateTemplateVariableIntoHTMLV3(data.WhatsApp.FollowUpMessage);
            tempWhatsApp.templateParameters = [];
            if (data.WhatsApp.TemplateParameters && data.WhatsApp.TemplateParameters.length > 0) {
              data.WhatsApp.TemplateParameters.map((item: any) => {
                let tempParam: any = {
                  "paraname": item.Paraname,
                  "position": item.Position,
                  "value": item.Value,
                }
                tempWhatsApp.templateParameters.push(tempParam);
              })
            }

            if (this.shareConfigService.clientWhatsappTemplates && Object.keys(this.shareConfigService.clientWhatsappTemplates).length > 0) {
              if (this.shareConfigService.clientWhatsappTemplates[tempWhatsApp.hsmTemplateLanguageCode]) {
                let templateData: any = JSON.parse(JSON.stringify(this.shareConfigService.clientWhatsappTemplates[tempWhatsApp.hsmTemplateLanguageCode]));
                this.shareConfigService.selectedWhatsAppTemplate[this.notificationType] = {};
                this.shareConfigService.activeCommunicationTab = this.notificationType;
                if (templateData && templateData.length > 0) {
                  templateData.map((item: any) => {
                    if (item.id == tempWhatsApp.hsmTemplateId) {
                      isTemplateIdValid = true;
                      this.shareConfigService.selectedWhatsAppTemplate[this.notificationType] = JSON.parse(JSON.stringify(item));
                    }
                  }, this);
                  if (!isTemplateIdValid) {
                    this.shareConfigService.selectedWhatsAppTemplate[this.notificationType] = JSON.parse(JSON.stringify(templateData[0]));
                  }
                  this.shareConfigService.selectedWhatsAppTemplate[this.notificationType].followUpMessage = tempWhatsApp.followUpMessage;
                  this.shareConfigService.selectedWhatsAppTemplate[this.notificationType].params = tempWhatsApp.templateParameters;
                }
              }
            }
          }
          const control = <FormArray>this.addEmailForm.controls['TemplateAttachmentList'];
          for (let i = control.length - 1; i >= 0; i--) {
            control.removeAt(i)
          }
          data.TemplateAttachmentList.forEach((ele) => {
            (<FormArray>this.addEmailForm.get("TemplateAttachmentList")).push(
              new FormGroup({
                FileName: new FormControl(ele.FileName),
                FileUrl: new FormControl(ele.FileUrl),
                FileIdentifier: new FormControl(ele.FileIdentifier)
              })
            )
          })
          $('#charNums').text(this.addEmailForm.controls.SMSText.value.length);
          this.isReadyToViewWhatsAppTemplate = true;
        },
        error => {
          this.sharedService.getTranslatedNotification(25);
          this.loaderService.hide();
        }
      );
  }

  /**
   * Function to create form
   */
  private createForm() {
    this.addEmailForm = this._fb.group({
      Id: [this.templateId],
      OfficeId: [this.officeId],
      NotificationType: [this.notificationType],
      Subject: [""],
      EmailLinkVariable : new FormControl(""),
      Body: [""],
      SMSText: [""],
      QuizInTemplateList: new FormArray([]),
      TemplateAttachmentList: new FormArray([])
      // AppointTypeList: ['']
    });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;
    if(k == 45 || k == 95){
      return true;
    }
    if(k == 32){
      return false;
    }
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData
    let pastedText = clipboardData.getData('text');
    pastedText = pastedText.replace(/ +/g, "");
    var last = pastedText.replace(/[^0-9a-zA-Z-_ ]/g,'')
    var first = this.addEmailForm.controls.EmailLinkVariable.value
    this.addEmailForm.controls.EmailLinkVariable.patchValue(first+last);
    event.preventDefault();
  }

    /**
   ** Callback when image is inserted using media widget
   * @param data : Data received from the Media widget
   */
  whenImageInsertedUsingMediaWidget(data,shareTemplate) {
    
    data.assets.forEach(asset => {
      let imageUrl = asset.derived ? asset.derived[0].secure_url : asset.secure_url;
      this.imageORvideo = QuizHelperUtil.getFileType(imageUrl);
      this.imageURL = `<img src="${imageUrl}">`;
      this.openImageModal(imageUrl, shareTemplate);
    });
  }


    /**
   * *Callback when image is inserted using upload widget
   * @param callbackObject { error: any, result : any}
   */
  whenImageInsertedUsingUploadWidget(callbackObject: { error: any, result: any },shareTemplate): void {
    
    let error = callbackObject.error;
    let result = callbackObject.result

    if (!error && result[0].url) {
      this.imageORvideo = QuizHelperUtil.getFileType(result[0].url);
      let url = QuizHelperUtil.applyCoorniateFacesInUrl(result[0].url, result[0].coordinates)
      this.imageURL = `<img src="${url}">`;
      this.openImageModal(url, shareTemplate);
    } else {
      console.log(
        "Error! Cloudinary upload widget error questionImage",
        error
      );
    }

  }



  pasteHtmlAtCaret(html) {
    var sel, range;
    if (window.getSelection) {
      // IE9 and non-IE
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();

        // Range.createContextualFragment() would be useful here but is
        // non-standard and not supported in all browsers (IE9, for one)
        var el = document.createElement("div");
        el.innerHTML = html;
        var frag = document.createDocumentFragment(),
          node,
          lastNode;
        while ((node = el.firstChild)) {
          lastNode = frag.appendChild(node);
        }
        range.insertNode(frag);

        // Preserve the selection
        if (lastNode) {
          range = range.cloneRange();
          range.setStartAfter(lastNode);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    }
  }

  smsDefaultTemplate() {
    this.loaderService.show();
    this.defaultTemplateSubscription = this.appointmentsService
      .getDefaultTemplate(this.notificationType)
      .subscribe(
        data => {
          this.loaderService.hide();
          this.addEmailForm.patchValue({
            Body: data.Body,
            SMSText: data.SMSText,
            Subject: data.Subject,
            QuizInTemplateList: data.QuizInTemplateList,
            TemplateAttachmentList:  data.TemplateAttachmentList
          });
          $('#charNums').text(this.addEmailForm.controls.SMSText.value.length);
        },
        error => {
          this.loaderService.hide();
        }
      );
  }

  onUseMedia(shareTemplate){
    this.shareTemplate = shareTemplate;
    this.isVisibleMediaLibrary=true;
  }

  changeUploadedImageUrl(event){
    this.isVisibleMediaLibrary=false;
    if(event.message == "success"){
      if (event.externalUrl) {
        var content = event.externalUrl.split(".");
        var contentType = content[content.length - 1];
        if (
          contentType === "jpg" ||
          contentType === "jpeg" ||
          contentType === "tiff" ||
          contentType === "jpg" ||
          contentType === "gif" ||
          contentType === "png" || 
          contentType === "svg" || 
          contentType === "" 
        ) {
          this.imageORvideo = "image";
        } else {
          this.imageORvideo = "video";
        }
      }
      if(this.imageORvideo == "image"){
        this.imageURL = `<img src="${event.externalUrl}">`;
        this.openImageModal(event.externalUrl, this.shareTemplate);
      }
    }
  }

  openImageModal(resultUrl, shareTemplate) {
    this.modalRef = this.modalService.show(shareTemplate);
  }

  
  

  /**
   * Modal Open for preview template
   * @param template: template reference (#preview)
   */
  openPreviewModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "modal-lg" });
  }

  /**
   * Modal for Default Template
   * @param template: template reference(#defaultTemplate)
   */
  openDefaultTemplateModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  /**
   * confirm Default template
   */
  confirmDefaultTemplate(): void {
    this.smsDefaultTemplate();
    this.modalRef.hide();
  }

  /**
   * Decline Default Template
   */
  declineDefaultTemplate(): void {
    this.modalRef.hide();
  }

  openPreviewEmailModal(template: TemplateRef<any>) {
     
    this.automationTemObjPreview = {};
    this.automationTemObjPreview.subject = JSON.parse(JSON.stringify(this.addEmailForm.controls.Subject.value));
    this.automationTemObjPreview.messageText = JSON.parse(JSON.stringify(this.addEmailForm.controls.Body.value));

    this.automationTemObjPreview.messageText = this.variablePopupService.addInlineCSSForParagraphStyle(this.automationTemObjPreview.messageText);
    // let listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObj(this.automationTemObjPreview.messageText);
    let listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObjV3(this.automationTemObjPreview.messageText);
    if(this.automationTemObjPreview.messageText && listOfUsedVariableObj && listOfUsedVariableObj.length > 0 && 
      (this.automationTemObjPreview.messageText.includes("#signature%") || this.automationTemObjPreview.messageText.includes("#atype%") || 
      this.details.LeadUser && Object.keys(this.details.LeadUser).length > 0)
    ){
      listOfUsedVariableObj.map((itemObj:any) => {
        // let doc = new DOMParser().parseFromString(this.automationTemObjPreview.messageText, 'text/html');
        // if(doc.getElementById(itemObj.formula)){
        //   let outerhtml = doc.getElementById(itemObj.formula).outerHTML;
          let valueToUpdate = "";
          switch (itemObj.formula) {
            case "%fname%":
              valueToUpdate = this.details.LeadUser.FirstName ? this.details.LeadUser.FirstName : "";
              break;
            case "%lname%":
              valueToUpdate = this.details.LeadUser.LastName ? this.details.LeadUser.LastName : "";
              break;
            case "%phone%":
              valueToUpdate = this.details.LeadUser.PhoneNumber ? this.details.LeadUser.PhoneNumber : "";
              break;
            case "%email%":
              valueToUpdate = this.details.LeadUser.UserName ? this.details.LeadUser.UserName : "";
              break;
            case "%leadid%":
              valueToUpdate = this.details.LeadUser.UserId ? this.details.LeadUser.UserId : "";
              break;
            case "%sourcename%":
              valueToUpdate = "";
              break;
            case "%atype%":
              valueToUpdate = this.details.AppointmentTypeName ? this.details.AppointmentTypeName : "";
              break;
            case "%duration%" :
              valueToUpdate = this.details.Duration ? this.details.Duration : "";
              break;
            case "%signature%":
              valueToUpdate = this.emailSignature ? this.emailSignature : "";
              valueToUpdate = valueToUpdate.replace("%rfname%",(this.details.LeadUser.FirstName ? this.details.LeadUser.FirstName : ""))
                                           .replace("%rlname%",(this.details.LeadUser.LastName ? this.details.LeadUser.LastName : ""))
                                           .replace("%remail%",(this.details.LeadUser.UserName ? this.details.LeadUser.UserName : ""))
                                           .replace("%rphone%",(this.details.LeadUser.PhoneNumber ? this.details.LeadUser.PhoneNumber : ""));
              break;
          }
          if(valueToUpdate){
            // this.automationTemObjPreview.messageText = this.variablePopupService.removeVariableHTMLStructure(this.automationTemObjPreview.messageText,itemObj,doc,'body');
            this.automationTemObjPreview.messageText = this.variablePopupService.removeVarHTMLStructureCommon(this.automationTemObjPreview.messageText,itemObj);
            this.automationTemObjPreview.messageText = this.automationTemObjPreview.messageText.replace(itemObj.formula,valueToUpdate);
          }
        // }
      });
    }
    this.modalRef = this.modalService.show(template, { class: "modal-lg"});
  }

  getTempSignature(clientCode){
    let type = 2;
    this.slotsService.getTemplateSignatureByClientCode(type,clientCode, true).subscribe(res => {
      this.emailSignature = '';
      if(res){
        this.emailSignature = res.signatureText;
      }
    });
  }

  countChar(event){
    $('#charNums').text(event.target.value.length);
  }

  onFilterList() {
    this.isFilterList = !this.isFilterList;
  }

  openVariablePopup(){
    this.isEmailVariablesPopupEnabled = true;
    let variablePopupPayload: any = {};
    let msg= this.froalaEditorOptions.editorRefernce.html.get(); 
    
    // variablePopupPayload.listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObj(msg);   
    variablePopupPayload.listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObjV3(msg);   
    variablePopupPayload.allowedVariblesFor = this.allowedVariblesFor;
    variablePopupPayload.isOpenPopup = true;
    variablePopupPayload.communicationType = "emailMsg";
    this.variablePopupService.variablePopupOpened = 'normal';

    this.variablePopupService.variablePopupPayload = variablePopupPayload;
    this.variablePopupService.changeInVariablePopupPayload();
  }

  openVariablePopupSms(){
    this.isEmailVariablesPopupEnabled = true;
    let variablePopupPayload: any = {};
    let msg=this.froalaEditorOptionsSMS.editorRefernce.html.get();
    // variablePopupPayload.listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObj(msg);   
    variablePopupPayload.listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObjV3(msg);   
    variablePopupPayload.allowedVariblesFor = this.allowedVariblesFor;
    variablePopupPayload.isOpenPopup = true;
    variablePopupPayload.communicationType = "smsMsg";
    this.variablePopupService.variablePopupOpened = 'sms';

    this.variablePopupService.variablePopupPayload = variablePopupPayload;
    this.variablePopupService.changeInVariablePopupPayload();
  }

  UpdatePopUpStatus(e){ 
    this.isOpenPopup = e; 
    if(!this.shareConfigService.listOfUsedVariableObj[this.notificationType]){
      this.shareConfigService.listOfUsedVariableObj[this.notificationType] = {};
    }
    if(this.variablePopupService.variablePopupOpened == 'sms'){
      this.addEmailForm.patchValue({
      //  SMSText : this.variablePopupService.insertFormulaIntoEditor(this.variablePopupService.listOfUsedVariableObj, this.froalaEditorOptionsSMS)
       SMSText : this.variablePopupService.insertFormulaIntoEditorV3(this.variablePopupService.listOfUsedVariableObj, this.froalaEditorOptionsSMS)
      });
      this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.SmsTemplateMsg] = [];
      if(this.variablePopupService.listOfUsedVariableObj && this.variablePopupService.listOfUsedVariableObj.length > 0){
        this.variablePopupService.listOfUsedVariableObj.map((item:any) => {
          this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.SmsTemplateMsg].push(item.formula);
        })
      } 
    }else{
      this.addEmailForm.patchValue({
      //  Body : this.variablePopupService.insertFormulaIntoEditor(this.variablePopupService.listOfUsedVariableObj, this.froalaEditorOptions)
       Body : this.variablePopupService.insertFormulaIntoEditorV3(this.variablePopupService.listOfUsedVariableObj, this.froalaEditorOptions)
      });
      this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.EmailTemplateMsg] = [];
      if(this.variablePopupService.listOfUsedVariableObj && this.variablePopupService.listOfUsedVariableObj.length > 0){
        this.variablePopupService.listOfUsedVariableObj.map((item:any) => {
          this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.EmailTemplateMsg].push(item.formula);
        })
      }
    }
    this.isEmailVariablesPopupEnabled = false;
  }

  CancelPopUpStatus(e){
    this.isOpenPopup = e; 
    this.isEmailVariablesPopupEnabled = false;
  }

    // Get All Languages
    getAllLanguageList() {
      this.shareConfigService.languageNameByCode = {};
      this.appointmentsService.getAllLanguageList(true).subscribe(response => {
        if (response.data && response.data.length > 0) {
          response.data.map(langObj => {
            this.shareConfigService.languageNameByCode[langObj.code] = langObj.name;
          })
        }
        // Get WhatsApp HSM Templates
        this.getWhatsAppHSMTemplates("appointment");
      })
    }
  
    // Get WhatsApp HSM Templates
    getWhatsAppHSMTemplates(code: string) {
      this.shareConfigService.clientWhatsappTemplates = {};
      this.appointmentsService.getWhatsAppHSMTemplates(code, true).subscribe((response: any) => {
        if (response && response.length > 0) {
          let templateListByCode = {};
          response.map((currentObj: any) => {
            if (!templateListByCode[currentObj.templateLanguage]) {
              templateListByCode[currentObj.templateLanguage] = [];
            }
            templateListByCode[currentObj.templateLanguage].push(currentObj);
          });
          this.isValidWhatsAppTemplate = true;
          this.shareConfigService.clientWhatsappTemplates = templateListByCode;
        }
        else{
          this.isValidWhatsAppTemplate = false;
        }
      });
  
    }

    smsChange(data) {
      this.addEmailForm.patchValue({
        SMSText : data
       });
    }

  ngOnDestroy() {
    try {
      this.getTemplateSubscription.unsubscribe();
      this.templateSubscription.unsubscribe();
    } catch (e) {
      console.log(e);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/recruiter-reschedule/recruiter-reschedule.component.ts